import { FileBase64 } from "../../../../model/file-base-64";
import { Pagination } from "../../../../model/pagination";
import { ISubmissionPublicationPagedRequest } from "../../../../model/sep/submission-publications/request/submissin-publication-paged-request";
import { ISubmissionPublicationUpdateRequest } from "../../../../model/sep/submission-publications/request/submissin-publication-update-request";
import { IUserSendSubimissonPublicationRequest } from "../../../../model/sep/submission-publications/request/user-send-submisson-publication-request";
import { IStatusSubimissonPublicationResponse } from "../../../../model/sep/submission-publications/response/status-submission-publication-response";
import { ISubmissionPublicationDetailResponse } from "../../../../model/sep/submission-publications/response/submissin-publication-detail-response";
import { ISubmissionPublicationFileResponse } from "../../../../model/sep/submission-publications/response/submissin-publication-file-response";
import { ISubimissonPublicationPagedResponse } from "../../../../model/sep/submission-publications/response/submissin-publication-paged-response";
import { IUserSendSubimissonPublicationResponse } from "../../../../model/sep/submission-publications/response/user-send-submission-publication-response";
import HttpClient from "../../../services/http-client";

const defaultPath = 'SubmissionPublication';

const findUsersSend = async (params: IUserSendSubimissonPublicationRequest): Promise<IUserSendSubimissonPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/UsersSend`,
        params: params
    }).then((response) => Object.assign([] as IUserSendSubimissonPublicationResponse[], response.data));
};


const update = async (content: ISubmissionPublicationUpdateRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${content.id}`,
        data: content
    });
};


const get = async (params: ISubmissionPublicationPagedRequest): Promise<Pagination<ISubimissonPublicationPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<ISubimissonPublicationPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<ISubmissionPublicationDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as ISubmissionPublicationDetailResponse, response.data));
};


const listFiles = async (id: number): Promise<ISubmissionPublicationFileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/Files`
    }).then((response) => Object.assign([] as unknown as ISubmissionPublicationFileResponse, response.data));
};


const downloadFiles = async (id?: number): Promise<FileBase64> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/Files/Download`
    }).then((response) => Object.assign(new FileBase64(), response.data));
};

const downloadFile = async (id: number, idFile: number): Promise<FileBase64> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/File/Download/${idFile}`
    }).then((response) => Object.assign(new FileBase64(), response.data));
};


const listStatus = async (): Promise<IStatusSubimissonPublicationResponse[]> => {
    return await
        HttpClient.executeRequest({
            method: 'get',
            url: `/${defaultPath}/Status`
        }).then((response) => Object.assign([] as IStatusSubimissonPublicationResponse[], response.data));
};

const SubmissionPublicationAppService = {
    findUsersSend, listStatus, get, getById, listFiles, downloadFile, downloadFiles, update
};

export default SubmissionPublicationAppService;